import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useTranslate from '../../../core/languages/hooks/useTranslate';

interface LocationDetailsInputProps {
    locationId: number | null | undefined;
    fieldName: string;
    label: string;
}

const LocationDetailsInput: React.FC<LocationDetailsInputProps> = ({ locationId, fieldName, label }) => {
    const t = useTranslate();
    const { control, formState: { errors } } = useFormContext();

    if (!locationId) {
        return null;
    }

    return (
        <div className="mt-4">
            <Controller
                name={fieldName}
                control={control}
                rules={{ 
                    required: t('common.feedback.field_required')
                }}
                render={({ field }) => (
                    <div>
                        <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                            {label}
                        </label>
                        <input
                            {...field}
                            type="text"
                            placeholder={t('transfers.message.enterAddressDetails')}
                            className="w-full px-4 py-2 border border-neutral-200 dark:border-neutral-700 rounded-lg
                            bg-white dark:bg-neutral-900 text-neutral-900 dark:text-white placeholder-neutral-400
                            dark:placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {errors[fieldName] && (
                            <p className="mt-1 text-sm text-red-600">
                                {errors[fieldName]?.message as string}
                            </p>
                        )}
                    </div>
                )}
            />
        </div>
    );
};

export default LocationDetailsInput;

